import EditIcon from "../../../assets/Edit.svg";
import DeleteIcon from "../../../assets/Delete.svg";

export default function RiserClampsTable({
  riserClampsData = [],
  onEdit,
  onDelete,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "20px",
        border: "1px solid #6B7280",
        borderRadius: "20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "minmax(150px, 2fr) minmax(100px, 1fr) minmax(250px, 3fr) minmax(100px, 1fr)",
          gap: "16px",
          padding: "13.5px 0 15px 0",
          borderBottom: "1px solid #D1D5DB",
        }}
      >
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Material
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Insulated
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Riser Clamp
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Action
        </p>
      </div>

      {riserClampsData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 0",
            color: "#6B7280",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          No riser clamps data available
        </div>
      ) : (
        riserClampsData.map((riserClamp, index) => (
          <div
            key={riserClamp.id}
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(150px, 2fr) minmax(100px, 1fr) minmax(250px, 3fr) minmax(100px, 1fr)",
              gap: "16px",
              padding: "13.5px 0",
              borderTop: index > 0 ? "1px solid #E5E7EB" : "none",
            }}
          >
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {riserClamp.material || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              {riserClamp.insulation ? "Yes" : "No"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {riserClamp.riser_clamp_product || "—"}
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer" }}
                onClick={() => onEdit && onEdit(riserClamp)}
              />
              <img
                src={DeleteIcon}
                alt="Delete"
                style={{ cursor: "pointer" }}
                onClick={() => onDelete && onDelete(riserClamp)}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
}
